import { DefaultThunk } from "stores";
import { getUid } from "stores/modules/app.user/selectors";
import { UpdateCharacter } from "stores/modules/entities.room.characters";
import { undoRedoReorderCharacters } from "stores/modules/entities.room.characters/operations";

export type OrderCharacterRecord = {
  kind: "change-character-index";
  id: string;
  beforeIndex: number;
  afterIndex: number;
  item: UpdateCharacter;
};

export const undoOrderCharacter =
  (history: OrderCharacterRecord): DefaultThunk =>
  (dispatch, getState) => {
    const roomId = getState().app.state.roomId;
    const uid = getUid(getState());
    if (!roomId || !uid) return;

    dispatch(
      undoRedoReorderCharacters(
        uid,
        roomId,
        history.id,
        history.beforeIndex,
        history.item
      )
    );
    return;
  };

export const redoOrderCharacter =
  (history: OrderCharacterRecord): DefaultThunk =>
  (dispatch, getState) => {
    const roomId = getState().app.state.roomId;
    const uid = getUid(getState());
    if (!roomId || !uid) return;

    dispatch(
      undoRedoReorderCharacters(
        uid,
        roomId,
        history.id,
        history.afterIndex,
        history.item
      )
    );
    return;
  };
